var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartInventorySync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m407.311 93.134c-87.072-80.117-221.774-77.525-305.7 5.881l45 45.252c61.755-61.243 161.464-60.827 222.707.928 12.946 13.054 23.506 28.275 31.202 44.972h-40.712l76.1 131.8 76.092-131.801h-43.11c-11.641-37.194-32.881-70.663-61.578-97.033zm-255.124 228.832h-37.739c36.284 78.98 129.723 113.593 208.703 77.309 16.818-7.726 32.142-18.359 45.267-31.409l45 45.252c-86.862 86.098-227.074 85.478-313.172-1.385-24.944-25.166-43.486-55.95-54.066-89.767h-46.18l76.089-131.8z",
    fill: "#0291f7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartInventorySync);
export default __webpack_public_path__ + "static/media/smart-inventory-sync.2b91f97c9b320a901162b429747cf5a1.svg";
export { ForwardRef as ReactComponent };